import {CommandBase} from "./CommandBase";
import {Asset} from "../entities/Asset";
import {CommandManager} from "../libs/CommandManager";

export class CommandDwellTimeCtrl extends CommandBase{
    selectedItems:any[];
    commandEnabled:boolean = false;
    dwellTime:number = 0;
    static $inject = ['CommandManager'];
    constructor(commandManager:CommandManager) {
        super(commandManager);
    }
    getCommandText(asset:Asset):string{
        return asset.vTagID + ":" + this.dwellTime;
    }
    getCommandType():string{
        return "Set Dwell Time";
    }
}

export class CommandDwellTimeDirective implements ng.IDirective {
    restrict= 'AEC';
    transclude = false;
    template = require('../../views/cmddwelltime.html').default;
    scope = {
        selectedItems : "=",
        commandEnabled : "=",
    };
    constructor() {
    }
    controller = CommandDwellTimeCtrl;
    controllerAs = "vm";
    link(scope: any, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any): void {
        //let url = controller.getUrl();
        //element.text('Current URL: ' + url);
        controller.commandEnabled = scope.commandEnabled;
        scope.$watch(()=>scope.selectedItems.length, (newVal:any)=> {
            controller.selectedItems = scope.selectedItems;
        });
        scope.$watch(()=>scope.commandEnabled, (newVal:any)=> {
            controller.commandEnabled = scope.commandEnabled;
        });
    }
    static factory():ng.IDirectiveFactory {
        var directive = () => {
            return new CommandDwellTimeDirective();
        }
        return directive;
    }
}
